import React from 'react';
import GlobalHelper from '../../Helpers/GlobalHelper';

const DateMinMask = (props) => {

    function convertDate() {
        return props.fecha ? GlobalHelper.FormatDate(props.fecha.slice(0, 19).replace('T', ' ')) : "-";
    }

    let fecha = convertDate();
    fecha = fecha != "-" ? fecha.slice(3, 10) : fecha;

    return (
        <span>{fecha}</span>
    );
}

export default DateMinMask;